import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import PRTPBanner from "../PRTPBanner/PRTPBanner";
import Image from "next/image";
import logo from "../../../assets/prtp/professional_research_training_program.svg";
import Link from "next/link";
import { Avatar, Chip } from "@mui/material";
import * as constants from "../../../Components/constants";

const BASE_URL = constants.BASE_URL;

function DrawerAppBar(props) {
  const [user, setUser] = React.useState("");
  const [localStoreId, setLocalStoreId] = React.useState("");

  React.useEffect(() => {
    const Id = localStorage.getItem("id");
    setLocalStoreId(Id);
  }, []);

  // Getting Login User
  React.useEffect(() => {
    fetch(`${BASE_URL}/user/user-general-info/${localStoreId}`, {
      method: "GET",
      headers: {
        Authorization: `Token ${localStorage.getItem("auth_token")}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setUser(data[0]);
      });
  }, [localStoreId]);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar component="nav" color="inherit" sx={{ boxShadow: "none" }}>
        <Toolbar>
          <Link href="/">
            <Image src={logo} width={130} height={80} alt="logo" priority />
          </Link>

          <Box
            sx={{ display: { xs: "none", sm: "block" }, flexGrow: 1 }}
            className="text-end"
          >
            {props.isLoggedIn === false && (
              <Link href="/user/login">
                <Chip variant="outlined" color="primary" label="Sign in" />
              </Link>
            )}

            {props.isLoggedIn === false && (
              <Link href="/user/registration">
                <Chip
                  className={`mx-2`}
                  variant="outlined"
                  color="success"
                  label="Sign up"
                />
              </Link>
            )}

            {props.isLoggedIn === true && (
              <Link href={`/user/${localStorage.getItem("id")}`}>
                <Button sx={{ fontWeight: "600" }}>
                  <Avatar
                    sx={{
                      width: 35,
                      height: 35,
                      border: 1,
                      borderColor: "grey.500",
                    }}
                    src={user?.profile_pic}
                    alt="home"
                  />
                </Button>
              </Link>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2, pt: 5 }}>
        <Toolbar />
        <PRTPBanner isLoggedIn={props.isLoggedIn} />
      </Box>
    </Box>
  );
}

DrawerAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default DrawerAppBar;
